import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;

  const logo = (
    <Box sx={{ width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1080.000000 1080.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)"
        >
          <path
            d="M910 7256 l0 -296 863 -2 862 -3 45 -25 c93 -53 132 -160 96 -266
-20 -60 -51 -96 -104 -123 -41 -21 -50 -21 -902 -21 l-860 0 0 -796 0 -795
923 4 c904 3 924 4 1018 25 396 90 634 308 700 641 16 81 6 239 -19 313 -24
72 -93 187 -135 224 -54 49 -151 110 -205 129 -29 11 -52 21 -52 24 0 4 24 17
52 31 69 33 176 140 215 215 59 114 81 273 58 407 -24 135 -84 254 -178 351
-107 110 -215 169 -412 225 l-90 26 -937 3 -938 4 0 -295z m1795 -1305 c22
-10 57 -36 77 -59 100 -111 67 -276 -69 -343 l-48 -24 -557 -3 -558 -3 0 226
0 225 558 0 c517 0 560 -2 597 -19z"
          />
          <path
            d="M4655 7543 c-303 -38 -575 -169 -780 -377 -150 -152 -248 -309 -300
-481 -15 -50 -31 -101 -36 -114 -15 -35 -39 -216 -39 -290 0 -59 3 -68 39
-115 125 -163 174 -364 141 -583 l-12 -84 38 -57 c21 -31 77 -96 124 -143 176
-177 395 -290 669 -346 64 -13 203 -16 849 -20 l772 -4 0 795 0 796 -765 0
-765 0 0 -275 0 -275 430 0 430 0 0 -225 0 -225 -322 0 c-385 1 -484 8 -598
46 -432 143 -605 679 -346 1072 97 147 233 244 413 294 76 22 96 22 756 26
l677 3 0 295 0 294 -672 -1 c-370 -1 -686 -4 -703 -6z"
          />
          <path
            d="M6250 7543 c0 -5 0 -593 -1 -1308 l0 -1300 345 -2 346 -1 0 543 c0
299 4 546 8 549 4 2 37 -25 72 -62 35 -37 145 -150 244 -252 100 -102 258
-265 351 -362 l170 -177 80 18 c167 38 482 135 649 200 l28 11 -83 78 c-200
185 -401 370 -503 462 -66 60 -186 171 -261 243 l-60 57 75 73 c72 69 225 209
319 293 24 21 58 52 75 68 17 16 96 88 176 160 80 71 154 139 165 151 12 11
43 40 70 64 114 102 283 259 323 300 23 24 42 40 42 35 0 -4 6 1 14 12 10 13
11 23 4 31 -7 9 -7 13 1 13 6 0 11 5 11 10 0 6 -38 10 -95 10 -57 0 -95 4 -95
10 0 9 25 12 143 13 38 1 47 4 47 19 0 17 -16 18 -217 20 l-218 3 290 5 c264
5 246 6 -205 8 l-496 2 -34 -31 c-19 -18 -154 -147 -300 -288 -374 -361 -358
-346 -577 -563 -110 -109 -203 -195 -206 -191 -4 3 -7 248 -7 544 l0 538 -345
1 c-190 0 -345 -3 -345 -7z m2570 -107 c0 -3 -4 -8 -10 -11 -5 -3 -10 -1 -10
4 0 6 5 11 10 11 6 0 10 -2 10 -4z m67 -22 c2 -7 -4 -11 -13 -10 -10 0 -23 -8
-28 -19 -6 -12 -21 -31 -33 -44 l-22 -24 19 54 c11 29 20 55 20 57 0 9 54 -5
57 -14z m-97 -39 c0 -14 -4 -25 -9 -25 -12 0 -23 29 -15 41 10 18 24 9 24 -16z
m-22 -59 c-7 -8 -15 -12 -17 -11 -5 6 10 25 20 25 5 0 4 -6 -3 -14z m-34 -48
c-3 -4 -11 -5 -19 -1 -21 7 -19 12 4 10 11 0 18 -5 15 -9z"
          />
          <path
            d="M8981 7494 c-35 -35 -22 -37 19 -3 19 15 28 28 20 28 -8 -1 -26 -12
-39 -25z"
          />
          <path
            d="M9445 7138 c-27 -11 -57 -26 -66 -34 -9 -8 -18 -12 -21 -9 -5 6 -68
-16 -135 -45 -31 -14 -32 -16 -37 -95 -10 -139 -13 -152 -15 -80 -1 39 -5 88
-10 110 -16 89 -31 -1138 -15 -1237 l7 -38 61 34 c122 66 181 100 191 108 6 5
32 22 58 39 l49 30 -7 617 c-4 339 -8 617 -9 618 0 0 -23 -8 -51 -18z m43
-377 l-3 -366 -5 365 -5 365 -5 -285 c-2 -157 -6 -248 -7 -202 -3 51 -8 82
-15 82 -8 0 -9 34 -5 118 6 115 6 120 -16 140 -13 12 -29 22 -35 22 -22 0 -12
20 22 42 34 23 54 73 32 81 -6 2 1 4 17 4 l27 1 -2 -367z m-60 337 c-4 -29
-55 -59 -67 -40 -7 11 -9 11 -14 -2 -6 -15 -37 -12 -37 4 0 10 40 22 67 20 14
-1 24 6 28 19 9 28 27 27 23 -1z m-100 -63 l42 -17 -36 -28 c-34 -25 -38 -26
-53 -11 -18 18 -24 84 -7 78 6 -3 30 -13 54 -22z m-90 -37 c-2 -12 -8 -23 -14
-25 -7 -2 -10 6 -7 22 6 30 26 34 21 3z m200 -76 l3 -42 -40 0 c-40 0 -41 1
-41 35 0 34 1 35 38 35 29 0 34 3 22 11 -13 9 -13 10 0 6 10 -2 16 -19 18 -45z"
          />
          <path d="M9173 7000 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z" />
          <path
            d="M8830 6714 c-74 -29 -147 -56 -162 -60 l-28 -6 0 -569 c0 -313 2
-569 5 -569 7 0 214 86 288 119 l67 31 0 555 c0 522 -1 555 -17 554 -10 -1
-79 -25 -153 -55z"
          />
          <path d="M9778 6673 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
          <path d="M9838 6663 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z" />
          <path d="M10333 6340 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z" />
          <path
            d="M8455 6358 c-16 -6 -68 -25 -115 -43 -47 -17 -113 -42 -147 -55 l-63
-22 0 -167 c0 -160 1 -167 23 -186 12 -10 93 -81 179 -157 86 -76 159 -138
162 -138 3 0 6 176 6 390 0 215 -3 390 -7 389 -5 0 -21 -5 -38 -11z"
          />
          <path d="M10072 6320 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
          <path
            d="M9961 6104 c-13 -15 -17 -24 -10 -22 12 4 46 48 37 48 -2 0 -15 -12
-27 -26z"
          />
          <path
            d="M10159 5993 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"
          />
          <path d="M9735 5889 c-11 -17 1 -21 15 -4 8 9 8 15 2 15 -6 0 -14 -5 -17 -11z" />
          <path
            d="M9630 5799 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"
          />
          <path d="M9580 5776 c-9 -12 -8 -15 8 -13 12 0 18 6 15 14 -6 16 -8 16 -23 -1z" />
          <path d="M9869 5733 l-24 -27 33 23 c32 23 39 31 24 31 -5 0 -19 -12 -33 -27z" />
          <path d="M9774 5658 l-19 -21 28 18 c28 18 33 25 19 25 -5 0 -17 -10 -28 -22z" />
          <path
            d="M9360 5635 c-42 -31 -34 -32 17 -4 47 26 50 29 32 29 -8 -1 -30 -12
-49 -25z"
          />
          <path
            d="M9715 5630 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0
-13 -4 -16 -10z"
          />
          <path d="M9670 5590 c-13 -8 -13 -10 2 -10 9 0 20 5 23 10 8 13 -5 13 -25 0z" />
          <path
            d="M9635 5570 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"
          />
          <path
            d="M9165 5520 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6
0 -7 -4 -4 -10z"
          />
          <path
            d="M9545 5510 c-4 -6 -16 -8 -28 -5 -18 5 -19 4 -7 -4 13 -10 13 -12 0
-21 -8 -5 -10 -10 -5 -9 15 0 72 49 58 49 -6 0 -15 -5 -18 -10z"
          />
          <path
            d="M9135 5500 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0
-13 -4 -16 -10z"
          />
          <path
            d="M9166 5474 c-5 -14 -4 -15 9 -4 17 14 19 20 6 20 -5 0 -12 -7 -15
-16z"
          />
          <path
            d="M8960 5419 c-51 -27 -48 -30 13 -13 21 6 66 45 50 43 -4 0 -33 -14
-63 -30z"
          />
          <path d="M9285 5410 c-8 -13 5 -13 25 0 13 8 13 10 -2 10 -9 0 -20 -4 -23 -10z" />
          <path d="M9374 5404 c-18 -14 -18 -15 4 -4 12 6 22 13 22 15 0 8 -5 6 -26 -11z" />
          <path d="M8970 5384 l-35 -13 36 0 c21 -1 42 5 49 14 16 19 1 19 -50 -1z" />
          <path d="M9305 5380 c-8 -13 5 -13 25 0 13 8 13 10 -2 10 -9 0 -20 -4 -23 -10z" />
          <path
            d="M9223 5338 c-13 -6 -23 -15 -23 -20 0 -4 -9 -8 -19 -8 -11 0 -23 -5
-27 -11 -9 -15 26 -3 79 27 41 23 33 33 -10 12z"
          />
          <path d="M8763 5330 c-34 -14 -28 -21 7 -9 17 6 30 13 30 15 0 6 -12 4 -37 -6z" />
          <path d="M8690 5294 l-25 -15 25 7 c14 3 29 10 35 15 15 14 -7 10 -35 -7z" />
          <path
            d="M9125 5280 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"
          />
          <path
            d="M9040 5249 c-19 -11 -45 -19 -57 -19 -13 0 -23 -4 -23 -10 0 -5 7
-10 15 -10 18 0 125 47 125 54 0 10 -24 4 -60 -15z"
          />
          <path
            d="M8545 5235 c-27 -13 -45 -24 -39 -25 6 0 24 6 40 13 16 8 40 19 54
25 14 6 18 11 10 11 -8 0 -37 -11 -65 -24z"
          />
          <path d="M8601 5220 c-9 -5 -5 -9 10 -13 28 -7 31 -6 14 10 -6 6 -18 8 -24 3z" />
          <path
            d="M8845 5190 c-13 -5 -14 -9 -5 -9 8 0 24 4 35 9 13 5 14 9 5 9 -8 0
-24 -4 -35 -9z"
          />
          <path
            d="M8871 5173 c-36 -15 -60 -28 -54 -30 7 -3 43 9 80 26 83 37 63 40
-26 4z"
          />
          <path
            d="M8415 5180 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0
-13 -4 -16 -10z"
          />
          <path
            d="M8353 5164 c-22 -7 -56 -19 -75 -27 -18 -9 -42 -18 -53 -21 -11 -3
-4 -3 15 0 19 2 53 5 75 5 39 1 39 1 10 9 -31 8 -29 10 15 14 14 2 33 6 43 11
10 4 17 3 17 -4 0 -6 10 -11 23 -10 14 0 17 2 7 6 -8 3 -19 11 -25 17 -8 9
-19 9 -52 0z"
          />
          <path d="M8380 5131 c0 -14 18 -23 31 -15 8 4 7 9 -2 15 -18 11 -29 11 -29 0z" />
          <path
            d="M8693 5108 c7 -4 -1 -10 -20 -14 -18 -4 -33 -10 -33 -14 0 -8 53 6
110 28 20 8 17 9 -22 8 -25 -1 -41 -4 -35 -8z"
          />
          <path d="M8163 5093 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
          <path d="M8266 5085 c-4 -11 1 -14 16 -11 12 1 24 8 26 14 6 18 -35 14 -42 -3z" />
          <path
            d="M8075 5071 c-6 -5 -48 -20 -95 -32 -84 -24 -85 -24 -45 -30 26 -4 31
-7 15 -8 -14 -1 -32 -6 -40 -12 -13 -9 -13 -10 0 -8 32 3 60 -1 60 -10 0 -6
-17 -7 -37 -4 l-38 6 23 -21 23 -20 -51 -7 c-43 -6 -50 -10 -50 -29 0 -22 -2
-22 -107 -20 -77 1 -92 0 -53 -5 l55 -7 -55 -8 c-34 -4 -74 -3 -104 4 -27 6
-83 11 -125 12 -73 1 -74 2 -31 10 25 5 60 13 77 18 18 4 35 4 38 0 3 -5 -3
-11 -12 -13 -12 -3 -9 -5 7 -5 30 0 84 16 58 17 -10 1 -18 6 -18 12 0 7 10 9
26 5 16 -4 23 -3 20 3 -4 6 9 13 29 17 19 3 35 10 35 14 0 4 -24 1 -52 -7 -58
-16 -312 -70 -367 -79 -19 -2 -39 -8 -45 -11 -6 -4 -22 -7 -36 -6 -22 1 -23 1
-2 -4 12 -2 22 -9 22 -14 0 -34 739 27 761 63 4 6 18 8 31 5 14 -4 49 0 79 8
30 8 86 22 124 31 64 15 212 57 309 89 l39 12 -59 0 c-43 0 -51 -2 -29 -7 l30
-6 -35 -7 c-95 -19 -130 -29 -130 -37 0 -4 -19 -10 -42 -13 -61 -8 -178 -35
-210 -48 -14 -6 -35 -9 -45 -6 -13 3 -11 5 7 6 14 1 32 6 40 12 11 8 5 9 -25
6 -22 -3 -51 -2 -65 2 -23 6 -23 8 -6 14 12 5 23 3 28 -5 6 -9 11 -9 14 -2 2
6 18 8 34 6 30 -4 30 -4 30 42 0 33 4 46 14 46 8 0 18 5 22 12 5 8 0 9 -14 6
-12 -4 -22 -2 -22 2 0 5 12 11 28 13 27 4 27 4 2 6 -15 0 -30 -3 -35 -8z m-9
-63 c4 -7 4 -10 -1 -6 -4 4 -14 3 -22 -3 -7 -6 -13 -8 -13 -4 0 5 -9 0 -19 -9
-12 -11 -21 -14 -26 -7 -3 6 1 11 9 11 9 0 15 3 15 8 -3 17 2 22 25 22 14 0
28 -6 32 -12z m-526 -158 l55 -7 -55 -2 c-30 0 -85 -4 -121 -7 -55 -6 -67 -4
-72 10 -6 14 3 16 66 15 40 -1 97 -4 127 -9z"
          />
          <path
            d="M8591 5071 c-14 -4 -27 -13 -29 -21 -4 -12 -2 -13 9 -2 7 6 21 12 30
12 10 0 21 5 24 10 7 11 2 11 -34 1z"
          />
          <path d="M8153 5043 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
          <path d="M8320 5024 c0 -8 9 -14 19 -14 30 0 34 17 6 22 -17 4 -25 1 -25 -8z" />
          <path
            d="M8390 5030 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10 -5
0 -3 -5 5 -10z"
          />
          <path d="M7860 5000 c-12 -8 -11 -10 8 -10 12 0 22 5 22 10 0 13 -11 13 -30 0z" />
          <path
            d="M7770 4978 c-47 -12 -57 -17 -34 -17 17 -1 44 4 61 9 20 8 38 8 57 0
17 -6 25 -6 21 0 -3 6 -12 10 -20 10 -7 0 -15 3 -17 8 -1 4 -32 -1 -68 -10z"
          />
          <path
            d="M8090 4950 c-11 -7 -5 -8 20 -4 43 8 51 14 19 14 -13 0 -31 -5 -39
-10z"
          />
          <path d="M7633 4893 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" />
          <path
            d="M7055 4830 c-4 -6 11 -10 39 -10 25 0 48 5 51 10 4 6 -11 10 -39 10
-25 0 -48 -4 -51 -10z"
          />
          <path
            d="M2067 4373 c-4 -3 -7 -224 -7 -490 l0 -484 433 3 432 3 93 33 c97 33
158 69 203 119 91 98 130 244 109 408 -20 155 -99 267 -235 331 -92 44 -165
61 -305 74 -128 11 -713 14 -723 3z m761 -222 c158 -42 231 -126 232 -267 0
-59 -5 -81 -28 -125 -63 -122 -188 -158 -539 -159 l-163 0 0 279 c0 214 3 281
13 284 23 10 442 -1 485 -12z"
          />
          <path
            d="M4410 4368 c-11 -13 -140 -209 -342 -519 -242 -370 -287 -442 -284
-448 4 -6 61 -7 226 -3 l96 2 37 63 c40 65 103 166 190 305 29 45 81 129 117
187 36 57 67 105 70 105 3 0 26 -35 51 -78 25 -42 115 -191 199 -329 l152
-253 137 -1 c75 0 146 -2 159 -3 13 -2 25 1 28 6 3 4 -43 86 -102 181 -111
177 -381 606 -414 657 -5 8 -28 43 -50 78 l-40 62 -109 0 c-76 0 -114 -4 -121
-12z"
          />
          <path
            d="M5624 4366 c-3 -7 -3 -55 -2 -107 3 -92 3 -94 28 -96 14 0 116 -1
228 -2 l202 -1 0 -379 0 -380 126 -3 c69 -2 128 -1 130 1 2 2 4 175 4 383 l0
378 216 0 c129 0 223 4 235 10 16 9 19 22 19 95 0 46 -3 91 -6 99 -6 15 -65
16 -591 16 -468 -1 -585 -3 -589 -14z"
          />
          <path
            d="M7798 4373 c-18 -4 -205 -280 -383 -562 -15 -25 -31 -49 -36 -55 -5
-6 -31 -45 -58 -86 -122 -186 -170 -264 -166 -269 3 -6 51 -7 220 -3 l100 2
105 171 c58 94 110 176 116 183 6 6 19 26 28 44 9 18 51 84 93 148 67 103 77
113 88 97 15 -22 291 -479 347 -575 l40 -68 139 -1 c76 -1 150 -2 164 -3 14
-1 26 2 28 5 2 7 -70 124 -337 546 -105 167 -195 311 -201 320 -5 10 -25 39
-43 66 l-34 47 -96 -1 c-54 -1 -105 -3 -114 -6z"
          />
        </g>
      </svg>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
